import { map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { select, Store } from '@ngrx/store';
import * as _ from 'lodash';
import { EquipmentActivity } from '../_models';
import { environment } from '../../../environments/environment';
import { AppState } from '../_reducers';
import { selectAllEquipmentActivities } from '../_selectors/equipmentActivity.selectors';

@Injectable()
export class EquipmentActivityService {
  private apiBaseUrl = environment.apiBaseUrl;
  equipmentActivityList$: Observable<EquipmentActivity[]>;

  constructor(
    private http: HttpClient,
    private store: Store<AppState>
  ) {
    this.equipmentActivityList$ = this.store.pipe(select(selectAllEquipmentActivities));
  }
  getEquipmentActivities(): Observable<EquipmentActivity[]> {
    return this.http
      .get<any>(this.apiBaseUrl + 'api/private/v1/equipmentActivities')
      .pipe(map((response) => response));
  }
  getEquipmentActivity(id: number): Observable<EquipmentActivity> {
    return this.http
      .get<any>(this.apiBaseUrl + 'api/private/v1/equipmentActivities/' + id)
      .pipe(map((response) => response));
  }
  saveEquipmentActivity(equipmentActivityItem): Observable<EquipmentActivity> {
    const equipmentActivity = { ...equipmentActivityItem };

    delete equipmentActivity.lastUpdated;
    delete equipmentActivity.dateCreated;

    if (equipmentActivity.people) {
      const arrpeople: Array<any> = [];
      equipmentActivity.people.forEach((element) => {
        const idpeople: any = {
          id: element.id,
        };
        arrpeople.push(idpeople);
      });
      equipmentActivity.people = arrpeople;
    }

    if (equipmentActivity.equipment) {
      const idequipment: any = {
        id: equipmentActivity.equipment.id,
      };
      equipmentActivity.equipment = idequipment;
    }

    const companySelected = JSON.parse(localStorage.getItem('companySelected'));
    equipmentActivity.companyId = companySelected ? companySelected.id : null;

    if (equipmentActivity.id) {
      return this.http
        .put<EquipmentActivity>(
          this.apiBaseUrl + 'api/private/v1/equipmentActivities/' + equipmentActivity.id,
          equipmentActivity
        )
        .pipe(map((response) => response));
    } else {
      return this.http
        .post<EquipmentActivity>(
          this.apiBaseUrl + 'api/private/v1/equipmentActivities/',
          equipmentActivity
        )
        .pipe(map((response) => response));
    }
  }
  deleteEquipmentActivity(id: number): Observable<EquipmentActivity> {
    return this.http.delete(this.apiBaseUrl + 'api/private/v1/equipmentActivities/' + id).pipe(
      map(() => {
        return { id } as EquipmentActivity;
      })
    );
  }

  getEquipmentActivitiesOPModule(farmsAppend): Observable<EquipmentActivity[]> {
    return this.http
      .get<any>(this.apiBaseUrl + 'api/private/v1/equipmentActivities/' + farmsAppend)
      .pipe(map((response) => response));
  }

  getEquipmentActivitiesByCostGenericId = (id: number): Array<EquipmentActivity> => {
    let equipmentActivitiesFiltered: Array<EquipmentActivity>;

    this.equipmentActivityList$.subscribe((equipmentActivities) => {
      equipmentActivitiesFiltered = _.filter(equipmentActivities, (f: any) => {
        return _.find(f.externalResources, (e: any) => {
          return e.externalId == id && e.externalSource == 'finance_service';
        });
      });
    });

    return equipmentActivitiesFiltered;
  };
}
